import React from 'react';

import { MessageOutlined } from '@ant-design/icons';

const NotificationCardCommentIcon = () => {
  return <MessageOutlined className="text-xl text-orange-500" />;
};

export default NotificationCardCommentIcon;
